import { motion } from "framer-motion";

export const StorytellingSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  const scaleVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section
      id="storytelling"
      className="pt-8 lg:pt-12"
      data-testid="storytelling-section"
    >
      {/* Storytelling Section - Image Left with Our Vision overlay, Text Right */}
      <div className="flex flex-col lg:flex-row h-[605px]">
        {/* Left - Image with Our Vision Overlay */}
        <div className="lg:w-1/2 relative h-full">
          <img 
            src="https://customer-assets.emergentagent.com/job_71d53eed-6c03-47ac-a417-1c0b12fdae5b/artifacts/iceyibxn_Summer%20Lake%20Tahoe%20Engagements%20__%20Monica%20%26%20Thomas.jpg"
            alt="Holding hands by the sea"
            className="w-full h-[605px] object-cover"
            data-testid="storytelling-hands-image"
          />
          {/* Dark overlay for better text readability */}
          <div className="absolute inset-0 bg-black/40" />
          
          {/* Our Vision Text Overlay */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-8">
            <motion.h2
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.5 }}
              transition={{ duration: 0.6 }}
              className="text-gold-500 font-medium text-sm tracking-wider uppercase mb-3 block drop-shadow-lg"
              style={{ textShadow: '1px 1px 4px rgba(0,0,0,0.5)' }}
              data-testid="services-label"
            >
              Our Vision
            </motion.h2>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.5 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="font-sans text-xl md:text-2xl lg:text-3xl font-[720] text-white drop-shadow-xl whitespace-nowrap"
              style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.8)' }}
              data-testid="services-title"
            >
              뉴 커플링은 진정한 사랑을 꿈꾸는 공간을 만듭니다
            </motion.h2>
          </div>
        </div>

        {/* Right - Storytelling Text with light gray background */}
        <div className="lg:w-1/2 bg-stone-100 flex items-center justify-center p-6 md:p-8 h-[605px] overflow-hidden">
          <motion.div 
            className="max-w-[420px] w-full"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
          >
            <motion.h2
              variants={itemVariants}
              className="text-gold-500 font-medium text-sm tracking-wider uppercase mb-3 block text-center"
            >
              Our Mission
            </motion.h2>
            <motion.p 
              variants={itemVariants}
              className="text-stone-800 text-2xl md:text-3xl mb-6 font-medium text-center italic"
            >
              "다시 설레일수 있을까?"
            </motion.p>
            
            {/* Main Content */}
            <div className="space-y-4 text-center">
              <motion.div variants={itemVariants}>
                <p className="text-stone-600 text-base leading-relaxed">
                  네 압니다. 저도 여러분들과 똑같은 감정을 느껴요.
                </p>
              </motion.div>
              
              <motion.div variants={itemVariants} className="space-y-1">
                <h3 className="text-stone-800 font-bold text-lg">나이가 들어간다는 불안감</h3>
                <h3 className="text-stone-800 font-bold text-lg">혼자라는 외로움</h3>
                <h3 className="text-stone-800 font-bold text-lg">새로운 관계에 대한 두려움</h3>
              </motion.div>
              
              <motion.div variants={itemVariants}>
                <p className="text-stone-600 text-base leading-relaxed">
                  그렇다고 이대로 시간을 흘려보낼수는 없습니다.
                </p>
              </motion.div>
              
              <motion.div variants={itemVariants} className="space-y-0.5">
                <p className="text-stone-600 text-base">불안감은 함께라는 커뮤니티로</p>
                <p className="text-stone-600 text-base">외로움은 커플링이라는 매칭 플렛폼으로</p>
                <p className="text-stone-600 text-base">두려움은 연애사관학교라는 배움으로</p>
              </motion.div>
              
              <motion.div variants={scaleVariants} className="pt-2">
                <p className="text-stone-800 font-bold text-lg">
                  우리는 다시 시작할수 있습니다.
                </p>
              </motion.div>
            </div>
            
            {/* Bottom quote */}
            <motion.div 
              variants={itemVariants}
              className="border-t border-stone-300 pt-4 mt-6"
            >
              <p className="text-stone-700 text-base font-medium text-center mb-1">
                연애는 우리를 살아있게 만들고
              </p>
              <p className="text-stone-700 text-base font-medium text-center mb-1">
                사랑은 나를 가장 나답게 만들며
              </p>
              <p className="text-stone-700 text-base font-medium text-center">
                관계는 남은인생을 더 따뜻하게 만듭니다
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
